import React from 'react'

import Page from 'components/Page'
import Header from './Header'
import About from './About'

class Homepage extends React.Component {
  handleArrowClick = () => {
    if (this.aboutSection) {
      this.aboutSection.scroll()
    }
  }

  render() {
    return (
      <Page title="The World’s Best Ranked Dating App for Queer Women">
        <Header onArrowClick={this.handleArrowClick} />
        <About ref={aboutSection => { this.aboutSection = aboutSection }} />
      </Page>
    )
  }
}

export default Homepage
